import en from './en'
export const Lang = {
    en
}
export const list = [{
    tit: 'English',
    val: 'en'
}]